exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.channel-title[data-v-bebe7a5c] {\n  font-size: 12px;\n  background-color: grey;\n  color: white;\n  display: inline;\n  padding: 2px 4px;\n  border-radius: 3px;\n}\n.video-id[data-v-bebe7a5c] {\n  font-size: 12px;\n  color: black;\n  font-weight: bold;\n}\n", ""]);

// exports
